import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Combobox as HeadlessCombobox } from '@flywire/react-headlessui';
import { cx } from '../../utils';
const useOptionClasses = ({ className }) => {
    return cx('min-h-12 p-4 text-sm text-gray-950', 'data-[pointer-disabled=false]:hover:bg-blue-600 data-[pointer-disabled=false]:hover:text-white pointer-events-auto', 'data-[active=true]:bg-blue-600 data-[active=true]:text-white data-[pointer-disabled=true]:pointer-events-none', className);
};
const OptionComponent = forwardRef(({ className, ...rest }, ref) => {
    const classes = useOptionClasses({ className });
    return _jsx(HeadlessCombobox.Option, { className: classes, ref: ref, ...rest });
});
OptionComponent.displayName = 'Option';
const Option = OptionComponent;
export { Option };
//# sourceMappingURL=Option.js.map